import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import uRLs from "../../../utils/baseUtils";
import DateConverter from "@heartinz/date_and_time_processor";
const TRACKING_STEPS_SEQUENCE = [
  { key: "CREATED", label: "Created" },
  { key: "PLACED", label: "Placed" },
  { key: "ACCEPTED", label: "Processed" },
    { key: "ADVANCEPENDING", label: "Advance Pending" },
  { key: "FOALLOCATED", label: "Field Officer Assigned " },
  { key: "FOASSESSMENTDONE", label: "Field Officer Assessment Done" },
  { key: "BOOKINGCONFIRMED", label: "Booking Confirmed" },
  { key: "GLMEASUREMENTDONE", label: "Measurement Done" },
  { key: "WORKINPROGRESS", label: "Work Started" },
  { key: "WORKCOMPLETED", label: "Work Completed" },
  { key: "BOOKINGCOMPLETED", label: "Booking Completed" }
];

export default function AdminBookingTimeline({
  isSelectedData,
  loading,
  onApprove,                // Added back for the ACCEPTED step action button
  handleBookingConfirm,
  handleOpenFOAssessment,   // Added back for FO allocation actions
  handleSaveMeasurement,    // Added back for saving acres
  measurement,              // Added back for input state
  setMeasurement,           // Added back for input setter
  handleUploadImages,       // Added back for image upload triggers
  setShowAssignOptions,
  setAssignModal,
  handleUploadWorkImages,
  setShowCompleteModal,
  canCompleteBooking,
  isSplitWorkCompleted

}) {
  // Safe array parsing
  const history = Array.isArray(isSelectedData?.bookingStatusHistory) ? isSelectedData.bookingStatusHistory : [];
const isSameMeasurement =
  Number(measurement) === Number(isSelectedData?.numberOfAcres);
  const [showConfirmBookingModal, setShowConfirmBookingModal] = useState(false);
  // Helper function to extract historical entry data details if present
  const getHistoryEntry = (statusKey) => {
    if (statusKey === "CREATED") {
      return history.find(s => s.bookingTracking === "CREATED") || history[0];
    }
    return history.find(s => s.bookingTracking === statusKey);
  };

  const hasBookingConfirmed = history.some(s => s.bookingTracking === "BOOKINGCONFIRMED");
  const isFoAllocatedCompleted = history.some(s => s.bookingTracking === "FOALLOCATED");
  const measureArray = isSelectedData?.measurementStatus || [];
  const latestMeasurement = measureArray?.[measureArray.length - 1];
 const handleOpenConfirmBooking = () => {
  setShowConfirmBookingModal(true);
};
const handleCloseConfirmBooking = () => {
  setShowConfirmBookingModal(false);
};
  const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
const missingSteps = {
  measurement: isSelectedData?.isMeasurement,
   geoImage: !!isSelectedData?.geoImage?.image,
  workStatus: isSelectedData?.workStatus === "COMPLETED",
  payment: Number(isSelectedData?.balanceAmount || 0) <= 0,
};
console.log("missingSteps",missingSteps)
  // A split booking's measurement/work-progress steps happen per Gang Leader
  // sub-booking now (see GangLeaderSubBookingTimeline), not on the primary —
  // this view becomes the primary/overall-status timeline only for those
  // bookings. A non-split booking renders every step exactly as before.
  const stepsToRender = isSelectedData?.supportsSplit
    ? TRACKING_STEPS_SEQUENCE.filter(s => !["GLMEASUREMENTDONE", "WORKINPROGRESS", "WORKCOMPLETED"].includes(s.key))
    : TRACKING_STEPS_SEQUENCE;
  return (
    <div className="timeline-wrapper p-3">

      {stepsToRender.map((step, index) => {
        const latestMeasurementStatus =
  measureArray?.[measureArray.length - 1]?.status || null;
     
      const matchedHistoryItem =
  step.key === "ADVANCEPENDING"
    ? getHistoryEntry("ADVANCEPAID") || getHistoryEntry("ADVANCEPENDING")
    : getHistoryEntry(step.key);
  const paymentStatusValue = matchedHistoryItem?.paymentStatus || null;
const isCompleted =
  step.key === "ADVANCEPENDING"
    ? paymentStatusValue === "PAID"
  :step.key === "GLMEASUREMENTDONE"
    ? latestMeasurementStatus === "ACCEPTED"
    : step.key === "WORKINPROGRESS"
    ? (
        isSelectedData?.workStatus === "STARTED" ||
        isSelectedData?.bookingStatusHistory?.some(
          (history) => history.bookingTracking === "WORKINPROGRESS"
        )
      )
    : step.key === "WORKCOMPLETED"
    ? (
        isSelectedData?.workStatus === "COMPLETED" ||
        isSelectedData?.bookingStatusHistory?.some(
          (history) => history.bookingTracking === "WORKCOMPLETED"
        )
      )
      : step.key === "BOOKINGCOMPLETED"
            ? (
                isSelectedData?.bookingStatus === "COMPLETED" || 
                isSelectedData?.lastStatus === "BOOKINGCOMPLETED"
                //  ||
                // completedKeys.includes("BOOKINGCOMPLETED")
              )
    : !!matchedHistoryItem;
    const completedKeys = history.map(item => item.bookingTracking);
const isCurrentPending = (() => {
  if (isCompleted) return false;

  // Accepted
   if (
    step.key === "ACCEPTED" &&
    completedKeys.includes("PLACED")
  ) {
    return true;
  }
if (
  step.key === "ADVANCEPENDING" &&(
  completedKeys.includes("ACCEPTED") ||
  completedKeys.includes("ADVANCEPAID"))
) {
  return true;
}
  if (
    step.key === "FOALLOCATED" &&
    completedKeys.includes("ACCEPTED") 
  ) {
    return true;
  }
  // FOASSESSMENTDONE should come after ADVANCEPENDING
  if (
    step.key === "FOASSESSMENTDONE" &&
    completedKeys.includes("FOALLOCATED") &&
    !completedKeys.includes("FOASSESSMENTDONE")
  ) {
    return true;
  }

  // ADVANCEPAID
  if (
    step.key === "ADVANCEPAID" &&
    completedKeys.includes("FOASSESSMENTDONE")
  ) {
    return true;
  }

  // BOOKINGCONFIRMED
  if (
    step.key === "BOOKINGCONFIRMED" &&
    completedKeys.includes("ADVANCEPAID")&&
     completedKeys.includes("FOASSESSMENTDONE")
  ) {
    return true;
  }
  //measuremnt
if (
  step.key === "GLMEASUREMENTDONE" &&
  completedKeys.includes("BOOKINGCONFIRMED") &&
  completedKeys.includes("FOASSESSMENTDONE") &&
  latestMeasurementStatus !== "ACCEPTED"
) {
  return true;
}


// work start
if (
  step.key === "WORKINPROGRESS" &&
  completedKeys.includes("GLMEASUREMENTDONE") &&
  completedKeys.includes("BOOKINGCONFIRMED") 
) {
  return true;
}

// WORK COMPLETED
if (
  step.key === "WORKCOMPLETED" &&
  (
    completedKeys.includes("WORKINPROGRESS") ||
    isSelectedData?.workStatus === "STARTED"
  )
) {
  return true;
}
// A split booking never gets WORKCOMPLETED on the primary (work is tracked
// per Gang Leader sub-booking), so offer completion once it is confirmed.
if (
  step.key === "BOOKINGCOMPLETED" &&
  (
    isSelectedData?.supportsSplit
      ? completedKeys.includes("BOOKINGCONFIRMED")
      : completedKeys.includes("WORKCOMPLETED")
  )
) {
  return true;
}

  return false;
})();
        const isFailed =
          step.key === "ADVANCEPENDING" &&
          paymentStatusValue === "FAILED";

        // Setup Layout Color Matrices
        let color = "#d6d6d6";          
        let txtColor = "#b0b0b0";       
        let icon = "bx-radio-circle";   
        let currentStatusClass = "";

        if (isCompleted) {
          color = "#28a745";            // Green for complete
          txtColor = "#28a745";          
          icon = "bx-check";            
        } else if (isFailed) {
          color = "#dc3545";
          txtColor = "#dc3545";
          icon = "bx-x";
        }
        else if (isCurrentPending) {
          color = "#ffc107";            // Yellow for active pending action item
          txtColor = "#ffc107";          
          icon = "bx-time";             
          currentStatusClass = "animate-pulse"; 
        }

        const showHistoryLine = index !== stepsToRender.length - 1;
        const entryByText = matchedHistoryItem?.entryBy || (isCompleted ? "OWNER" : "");
      

        return (<>
        
          <div key={step.key} className="d-flex position-relative">
            {/* Timeline Axis Visual Line Element */}
            
            <div className="me-3 d-flex flex-column align-items-center">
              <div
                className={`rounded-circle d-flex align-items-center justify-content-center p-1 border ${currentStatusClass}`}
                style={{ 
                  width: "24px", 
                  height: "24px", 
                  backgroundColor: color, 
                  borderColor: color, 
                  color: "#fff", 
                  zIndex: 1 
                }}
              >
                <i className={`bx ${icon} fs-6`}></i>
              </div>
              
              {showHistoryLine && (
                <div
                  className={`flex-grow-1`}
                  style={{ 
                    width: "2px", 
                    minHeight: "45px",
                    backgroundColor: isCompleted ? "#28a745" : "#e0e0e0",
                  }}
                ></div>
              )}
            </div>

            {/* Timeline Row Content Presentation Panel */}
            <div
              className="p-2 mb-3 w-100 rounded border"
              style={{ 
                backgroundColor: isCompleted ? "#f4fbf7" : isCurrentPending ? "#fff8e1" : "#fdfdfdb0", 
                borderLeft: `5px solid ${color}` 
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <p className="fw-bold mb-1" style={{ color: txtColor }}>
                  <p className="fw-bold mb-1" style={{ color: txtColor }}>
{step.key === "ACCEPTED"
  ? isCompleted
    ? "Processed"
    : "Accept Booking"

  : step.key === "ADVANCEPENDING"
  ? completedKeys.includes("ADVANCEPAID")
    ? "Advance Payment Completed"
    : "Advance Pending"

  : step.key === "GLMEASUREMENTDONE"
  ? latestMeasurementStatus === "ACCEPTED"
    ? "Measurement Done"
    : latestMeasurementStatus === "PENDING"
    ? "Waiting For Farmer Approval"
    : "Measurement Pending"

  : step.label}
</p>
                </p>
                {matchedHistoryItem?.amount && (
                  <h6 className="fw-bold mb-1" style={{ color: txtColor }}>
                    ₹{matchedHistoryItem.amount}
                  </h6>
                )}
              </div>

              {/* Action Source Attribution Label (Show only if completed) */}
              {isCompleted && (
                <p className="small text-muted mb-1">
                  By: <span className="fw-bold">{entryByText}</span>
                </p>
              )}

              <div className="d-flex justify-content-between align-items-center">
                {/* Datetime Stamp Conversion Field */}
               
                 {matchedHistoryItem?.time && (
                            <p className="small text-muted mb-1 mt-1">
                              <i className="bi bi-calendar-check me-1"></i>
                              <span className="me-1">
                                {DateConverter.ISOToDisplayFormat(DateConverter.convertToTimeZone(matchedHistoryItem?.time, uRLs.TIMEZONE)).time},
                              </span>
                              {DateConverter.ISOToDisplayFormat(DateConverter.convertToTimeZone(matchedHistoryItem?.time, uRLs.TIMEZONE)).date}
                            </p>
                          )}

                {paymentStatusValue && (
              <span
                className={`badge ${
                  paymentStatusValue === "PAID"
                    ? "bg-label-paid"
                    : paymentStatusValue === "STARTED"
                    ? "bg-warning text-dark"
                    : paymentStatusValue === "FAILED"
                    ? "bg-danger"
                    : "bg-label-secondary"
                }`}
                style={{ marginLeft: "5px" }}
              >
                {capitalize(paymentStatusValue)}
              </span>
            )}
              </div>

              {/* DYNAMIC ACTION INPUT CHANNELS: Renders exclusively when step is pending */}
              {isCurrentPending && (
                <div className="mt-0 pt-0 border-top border-light">
                  
                  {/* 1. Dynamic Action Box for ACCEPTED Milestone */}
                  {step.key === "ACCEPTED" && (
                    <div className="d-flex justify-content-end">
                      {loading?.status === isSelectedData?._id ? (
                        <button className="btn btn-primary btn-sm d-flex align-items-center" disabled>
                          <CircularProgress size={16} className="text-white me-2" /> Processing...
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() => onApprove(isSelectedData?._id)}
                        >
                          <i className="bx bx-check me-1"></i> Accept Booking
                        </button>
                      )}
                    </div>
                  )}

                  {/* 2. Dynamic Action Box for FOALLOCATED Milestone */}
                  {step.key === "FOALLOCATED" && (
                    <div className="d-flex justify-content-end">
                       <button
                          type="button"
                          className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                          onClick={() => {
                            setShowAssignOptions(false);
                            setAssignModal({ gangLeader: false, fieldOfficer: true });
                          }}           
                        >
                          <i className="bx bx-check fs-5"></i> Assign FieldOfficer
                        </button>
                    </div>
                  )}

                  {/* 3. Dynamic Action Box for FOASSESSMENTDONE Milestone */}
                  {step.key === "FOASSESSMENTDONE" && isFoAllocatedCompleted && (
                    <div className="d-flex justify-content-end">
                       <button className="btn btn-sm btn-primary" onClick={handleOpenFOAssessment}>
                          <i className="bx bx-check me-1"></i> Update Field Officer Assessment
                        </button>
                    </div>
                  )}

                  {/* 4. Dynamic Action Box for ADVANCEPAID / BOOKINGCONFIRMED workflow loops */}
                  {step.key === "BOOKINGCONFIRMED" && (
                    <div className="d-flex justify-content-end">
                       <button
                            type="button"
                            className="btn btn-sm btn-primary d-flex align-items-center gap-1 ms-auto"
                            // onClick={(e) => {
                            //   e.stopPropagation();
                            //   handleBookingConfirm(isSelectedData._id);
                            // }}
                             onClick={handleOpenConfirmBooking}
                            disabled={loading?.confirmBooking === isSelectedData._id}
                          >
                            <i className="bx bx-check fs-5"></i> Confirm Booking
                          </button>
                    </div>
                  )}

                  {/* 5. Dynamic Action Box for GLMEASUREMENTDONE Milestone */}
                  {step.key === "GLMEASUREMENTDONE" && !(latestMeasurementStatus === "PENDING") && (
                    <div className="d-flex align-items-center gap-2 justify-content-end">
                     <input
                      type="number"
                      className="form-control form-control-sm"
                      placeholder="Enter acres"
                      value={measurement}
                      onChange={(e) => {
                        let val = e.target.value;
                        if (val === "") { setMeasurement(""); return; }
                        if (/^\d+(\.\d{0,1})?$/.test(val)) { setMeasurement(val); }
                      }}
                      step="0.1"
                      min="0"
                      style={{ maxWidth: "130px" }}
                    />
                       {loading?.measureLoad ? (
                      <button className="btn btn-sm btn-primary" disabled>
                        <CircularProgress size={18} className="text-white" />
                      </button>
                    ) : (
                      <button className="btn btn-sm btn-primary d-flex align-items-center gap-1" onClick={handleSaveMeasurement}>
                        <i className="bx bx-check"></i>
                        {isSameMeasurement ? "Accept Measurement" : "Update Measurement"}
                      </button>
                    )}
                    </div>
                  )}

                  {/* 6. Dynamic Action Box for WORKINPROGRESS Milestone */}
                  {step.key === "WORKINPROGRESS" && (
  <div className="mt-2">
      {isSelectedData?.workImages?.length > 0 ? (
      <div>
       
        <div className="d-flex flex-wrap gap-2">
          {isSelectedData?.workImages?.map((img, i) => (
            <img
              key={i}
              src={img.image}
              alt="work"
              style={{
                width: "70px",
                height: "70px",
                objectFit: "cover",
                borderRadius: "8px",
                border: "1px solid #ddd"
              }}
            />
          ))}
        </div>
      </div>
    ) : (
      <div className="d-flex justify-content-end align-items-md-center flex-column flex-md-row">
      

        <div className="mt-2 mt-md-0" ms-auto>
          <button
            type="button"
            className="btn btn-sm btn-primary d-flex align-items-center gap-1 "
            onClick={(e) => {
              e.stopPropagation();
              handleUploadWorkImages();
            }}
          >
            <i className="bx bx-upload fs-6"></i>
            Upload Images
          </button>
        </div>
      </div>
    )}
  </div>
)}

{/* 7. WORKCOMPLETED */}
{step.key === "WORKCOMPLETED" && (
  <div className="d-flex justify-content-between align-items-md-center flex-column flex-md-row">

            <button type="button" className="ms-auto mt-2 btn btn-sm btn-primary d-flex align-items-center gap-1" onClick={(e) => { e.stopPropagation(); handleUploadImages(); }}>
                        <i className="bx bx-upload fs-6"></i> Upload Image
                      </button>
    </div>
)}

{step.key === "BOOKINGCOMPLETED" && (
  <>
  {!canCompleteBooking ? (
          <div className="mt-2 text-xs text-slate-500 space-y-1 bg-white p-2.5 rounded border border-amber-100 max-w-md p-2 mb-2">
            <p className="font-medium text-amber-800 mb-1">Please complete the following:</p>
            <ul className="space-y-1 list-none pl-0">
              {isSelectedData?.supportsSplit ? (
                !isSplitWorkCompleted && (
                  <li className="flex items-center text-rose-600">
                    Every Captain's measurement must be accepted and work completed (see Captain Allocations)
                  </li>
                )
              ) : (
              <>
              {!missingSteps.measurement && (
                <li className="flex items-center text-rose-600">
                   Measurement verification missing
                </li>
              )}
              {!missingSteps.geoImage && (
                <li className="flex items-center text-rose-600">
                   Geo image required
                </li>
              )}
              {!missingSteps.workStatus && (
                <li className="flex items-center text-rose-600">
                  <span className="mr-1.5">✕</span> Work status must be  COMPLETED
                </li>
              )}
              </>
              )}
              {!missingSteps.payment && (
                <li className="flex items-center text-rose-600">
                Please verify full payment completion
                </li>
              )}
            </ul>
          </div>
        ) : (
          <p className="text-sm text-emerald-700 font-medium mt-1">
            {/* ✓ All prerequisites met. Ready to finalize! */}
          </p>
        )}
    <button
              type="button"
             disabled={!canCompleteBooking}
              className={`btn btn-sm d-flex align-items-center gap-1 ms-auto
                 ${
                canCompleteBooking
                  ? "btn-primary"
                  : "btn-secondary"
              }
              `}
             onClick={() => {  
      setShowCompleteModal(true); // Open the validation modal
    
  }}
            >
              <i className="bx bx-check-circle"></i>

              Complete Booking
            </button>
             </>)
}
                </div>
              )}



              {step.key === "WORKINPROGRESS" && isCompleted && isSelectedData?.workImages?.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mt-0 pt-0 border-top border-light">
                  {isSelectedData.workImages.map((img, i) => (
                    <img key={i} src={img.image} alt="Work attachment" style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }} />
                  ))}
                </div>
              )}
{step.key === "WORKCOMPLETED" &&
  isCompleted &&
  isSelectedData?.geoImage?.image && (
    <div className="d-flex flex-wrap gap-2 mt-0 pt-0 border-top border-light">
      <img
        src={isSelectedData.geoImage.image}
        alt="Geo Attachment"
        style={{
          width: "70px",
          height: "70px",
          objectFit: "cover",
          borderRadius: "8px",
          border: "1px solid #ddd",
        }}
      />
    </div>
)}
            </div>
          </div></>
        );
      })}
      {showConfirmBookingModal && (
        <div>
           <div className="modal-backdrop show"></div>
        <div
        className="modal show d-block"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
      >
       
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content">
               <div className="modal-header border-bottom-0 p-2">
              <h6 className="modal-title fw-semibold">Confirm Booking Action</h6>
  <button
                type="button"
                className="btn-close border"
                onClick={handleCloseConfirmBooking}
              ></button>
              
              </div>
              <div className="modal-body py-3 mt-2 mb-2" >
                <p className="mb-0 text-muted">Are you sure you want to proceed and confirm this booking ?</p>
              </div>
              <div className="modal-footer border-top-0 pt-0 d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-sm btn-secondary" onClick={handleCloseConfirmBooking}>
                  No
                </button>
                <button type="button" className="btn btn-sm btn-primary" 
                  onClick={(e) => {
                              e.stopPropagation();                              
                              handleBookingConfirm(isSelectedData._id);
                                handleCloseConfirmBooking();
                            }}
                >
                  Yes, Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
      )}
    </div>
  );
}